import React from "react";
import { ErrorIcon, SearchIcon } from "../../assets/icon";

import s from "./SearchInput.module.scss";

function SearchInput({ ...props }) {
  const { label, onChange } = props;

  return (
    <div className={s.form_group}>
      <div className={s.input_box}>
				<SearchIcon width="15" height="15" viewBox=" 0 0 15 15" />
        <input
          type="search"
          id="country_name"
          placeholder={label}
					onChange={onChange}
        />
    </div>
    </div>
  );
}

export default SearchInput;
